(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-item"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const faqs = document.querySelectorAll(".faq-item");

  faqs.forEach(item => {
    const btn = item.querySelector(".faq-question");
    btn.addEventListener("click", () => {
      // close other open items (optional)
      faqs.forEach(i => {
        if (i !== item) i.classList.remove("active");
      });
      // toggle current
      item.classList.toggle("active");
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
